import React, { Fragment } from "react";
import { BEFORE_AND_AFTER_CURRENT_PAGE_COUNT } from "./constants";
import PagingButton from "./PagingButton";

export type TablePagingProps = {
  currentPage: number;
  rowsPerPage: number | null;
  totalRowCount: number;
  onPageChange: (pageNum: number) => void;
};

const PagingButtons = ({
  rowsPerPage,
  totalRowCount,
  currentPage,
  onPageChange,
}: TablePagingProps) => {
  if (!rowsPerPage) return null;
  const radius = BEFORE_AND_AFTER_CURRENT_PAGE_COUNT;
  const pageCount = Math.ceil(totalRowCount / rowsPerPage);

  const range = [...Array(radius * 2 + 1).keys()]; // pole [0,1,..., (2x radius + 1)]

  const indices = [1, pageCount] // Zační s 1. a posledním
    .concat(range.map((index) => index + currentPage - radius)) // Přidej radius kolem aktuálního
    .filter((index) => index >= 1 && index <= pageCount) // Odstraň přetékající
    .sort((a, b) => a - b); // Seřaď vzestupně

  const uniqueIndices = [...new Set(indices)]; // Odstraň duplikáty

  return (
    <div>
      {uniqueIndices.map((pageNumber) => (
        <PagingButton
          key={pageNumber}
          pageNumber={pageNumber}
          onClick={onPageChange}
          disabled={pageNumber === currentPage}
        />
      ))}
    </div>
  );
};

export default PagingButtons;
